export const PLAYER_PRESETS = {
    vertical: {
        colors: {
            background: 'rgba(0, 0, 0, 0.8)',
            text: '#ffffff',
            icon: '#ffffff',
            accent: '#4AE66E',
            timeBar: '#ffffff',
            liveIndicator: '#FF0000',
            buttonBackground: 'transparent',
            buttonShadow: 'rgba(0, 0, 0, 0.2)',
            backgroundShadow: 'rgba(0, 0, 0, 0.2)',
            borderColor: 'transparent'
        },
        settings: {
            radioName: true,
            liveIndicator: true,
            songName: true,
            artistName: true,
            timeBar: true,
            time: true,
            volumeControl: true,
            songHistory: true
        },
        dimensions: {
            width: '250px',
            height: 'auto',
            borderRadius: '8px',
            borderSize: '0px',
            padding: '15px',
            margin: '10px'
        },
        textAlign: 'center',
        albumArt: 'cover',
        fontFamily: 'poppins',
        fontSize: { value: 1, unit: 'rem' },
        fontWeight: '400',
        fontSpacing: {
            letterSpacing: { value: 0, unit: 'px' },
            lineHeight: { value: 1.5, unit: 'em' },
            wordSpacing: { value: 0, unit: 'px' }
        },
        buttonStyle: 'circle'
    },
    horizontal: {
        colors: {
            background: 'rgba(0, 0, 0, 0.8)',
            text: '#ffffff',
            icon: '#ffffff',
            accent: '#4AE66E',
            timeBar: '#ffffff',
            liveIndicator: '#FF0000',
            buttonBackground: 'transparent',
            buttonShadow: 'rgba(0, 0, 0, 0.2)',
            backgroundShadow: 'rgba(0, 0, 0, 0.2)'
        },
        settings: {
            radioName: true,
            liveIndicator: true,
            songName: true,
            artistName: true,
            timeBar: true,
            time: true,
            volumeControl: true,
            songHistory: true
        },
        dimensions: {
            width: '450px',
            height: 'auto',
            borderRadius: '8px',
            borderSize: '0px',
            padding: '15px',
            margin: '10px'
        },
        textAlign: 'left',
        albumArt: 'cover',
        fontFamily: 'poppins',
        fontSize: { value: 1, unit: 'rem' },
        fontWeight: '400',
        fontSpacing: {
            letterSpacing: { value: 0, unit: 'px' },
            lineHeight: { value: 1.5, unit: 'em' },
            wordSpacing: { value: 0, unit: 'px' }
        },
        buttonStyle: 'circle'
    },
    square: {
        colors: {
            background: 'rgba(0, 0, 0, 0.8)',
            text: '#ffffff',
            icon: '#ffffff',
            accent: '#4AE66E',
            timeBar: '#ffffff',
            liveIndicator: '#FF0000',
            buttonBackground: 'transparent',
            buttonShadow: 'rgba(0, 0, 0, 0.2)',
            backgroundShadow: 'rgba(0, 0, 0, 0.2)'
        },
        settings: {
            radioName: true,
            liveIndicator: true,
            songName: true,
            artistName: true,
            timeBar: true,
            time: true,
            volumeControl: true,
            songHistory: true
        },
        dimensions: {
            width: '250px',
            height: 'auto',
            borderRadius: '8px',
            borderSize: '0px',
            padding: '15px',
            margin: '10px'
        },
        textAlign: 'center',
        albumArt: 'cover',
        fontFamily: 'poppins',
        fontSize: { value: 1, unit: 'rem' },
        fontWeight: '400',
        fontSpacing: {
            letterSpacing: { value: 0, unit: 'px' },
            lineHeight: { value: 1.5, unit: 'em' },
            wordSpacing: { value: 0, unit: 'px' }
        },
        buttonStyle: 'circle'
    },
    footer: {
        colors: {
            background: 'rgba(0, 0, 0, 0.8)',
            text: '#ffffff',
            icon: '#ffffff',
            accent: '#4AE66E',
            timeBar: '#ffffff',
            liveIndicator: '#FF0000',
            buttonBackground: 'transparent',
            buttonShadow: 'rgba(0, 0, 0, 0.2)',
            backgroundShadow: 'rgba(0, 0, 0, 0.2)'
        },
        settings: {
            radioName: true,
            liveIndicator: true,
            songName: true,
            artistName: true,
            timeBar: true,
            time: true,
            volumeControl: true,
            songHistory: true
        },
        dimensions: {
            width: '450px',
            height: 'auto',
            borderRadius: '8px',
            borderSize: '0px',
            padding: '15px',
            margin: '10px'
        },
        textAlign: 'left',
        albumArt: 'cover',
        fontFamily: 'poppins',
        fontSize: { value: 1, unit: 'rem' },
        fontWeight: '400',
        fontSpacing: {
            letterSpacing: { value: 0, unit: 'px' },
            lineHeight: { value: 1.5, unit: 'em' },
            wordSpacing: { value: 0, unit: 'px' }
        },
        buttonStyle: 'circle'
    },
    compact: {
        colors: {
            background: 'rgba(0, 0, 0, 0.8)',
            text: '#ffffff',
            icon: '#ffffff',
            accent: '#4AE66E',
            timeBar: '#ffffff',
            liveIndicator: '#FF0000',
            buttonBackground: 'transparent',
            buttonShadow: 'rgba(0, 0, 0, 0.2)',
            backgroundShadow: 'rgba(0, 0, 0, 0.2)'
        },
        settings: {
            radioName: true,
            liveIndicator: true,
            songName: true,
            artistName: true,
            timeBar: true,
            time: true,
            volumeControl: true,
            songHistory: true
        },
        dimensions: {
            width: '450px',
            height: 'auto',
            borderRadius: '8px',
            borderSize: '0px',
            padding: '15px',
            margin: '10px'
        },
        textAlign: 'left',
        albumArt: 'cover',
        fontFamily: 'poppins',
        fontSize: { value: 1, unit: 'rem' },
        fontWeight: '400',
        fontSpacing: {
            letterSpacing: { value: 0, unit: 'px' },
            lineHeight: { value: 1.5, unit: 'em' },
            wordSpacing: { value: 0, unit: 'px' }
        },
        buttonStyle: 'circle'
    }
}; 